var map = {
	"./app-store.png": 9317,
	"./folder.png": 6318,
	"./music.png": 3113,
	"./pages.png": 9520,
	"./photos.png": 9525,
	"./reminder.png": 8784,
	"./safari.png": 1018,
	"./settings.png": 8393,
	"./ui.png": 944
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8956;